import {
  orderBookAxiosApi,
  profitsWsAxiosApi,
  cryptoStateAxiosApi,
  calculatorAxiosApi,
  predictionManagerAxiosApi,
  predictionCalculatorAxiosApi,
  predictionWsAxiosApi,
} from 'src/Config/axiosApi';

export const getAggregatorHealth = async () => {
  const res = await orderBookAxiosApi.get('/health');
  return res.data;
};

export const getProfitsWsHealth = async () => {
  const res = await profitsWsAxiosApi.get('/profits/health');
  return res.data;
};

export const getCryptoStateHealth = async () => {
  const res = await cryptoStateAxiosApi.get('/health/detailed');
  return res.data;
};

export const getCalculatorHealth = async () => {
  const res = await calculatorAxiosApi.get('/health');
  return res.data;
};

export const getPredictionManagerHealth = async () => {
  const res = await predictionManagerAxiosApi.get('/health');
  return res.data;
};

export const getPredictionCalculatorHealth = async () => {
  const res = await predictionCalculatorAxiosApi.get('/health');
  return res.data;
};

export const getPredictionWsHealth = async () => {
  const res = await predictionWsAxiosApi.get('/predictions/health');
  return res.data;
};
